import { Component, h, Host, Prop } from "@stencil/core";

/**
 * The `ux-headline` component is used to display headlines.
 * @slot - The default slot where headline content is placed.
 * @internal Currently only for usage in web-apps.
 */
@Component({
    tag: "ux-headline",
    styleUrl: "headline.scss",
    shadow: true
})
export class Headline {
    /**
     * The variant of the headline.
     */
    @Prop({ reflect: true }) readonly variant: "vast" | "giant" | "big" | "medium" | "small" = "medium";

    /**
     * The level of the headline.
     * 1 = H1
     * 2 = H2
     * ...
     */
    @Prop({ reflect: true }) readonly level!: string;

    /**
     * Whether the headline should be strong.
     */
    @Prop({ reflect: true }) readonly strong?: boolean;

    render() {
        return (
            <Host role="heading" aria-level={this.level}>
                <slot />
            </Host>
        );
    }
}
